import React from 'react';
import { Text } from 'src/@vymo/ui/atoms';
import { KEY_METRICS_DETAILS } from 'src/modules/constants';
import { renderModule } from 'src/workspace/slice';
import { isLmsWeb } from 'src/workspace/utils';

export const getIcon = (idx: any, type: any = 'h3') => {
  switch (idx) {
    case 0:
      return <Text type={type}>🥇</Text>;
    case 1:
      return <Text type={type}>🥈</Text>;
    case 2:
      return <Text type={type}>🥉</Text>;
    default:
      return null;
  }
};

export const getRank = (rank) => {
  if (rank <= 3) {
    return getIcon(rank - 1, 'h4');
  }
  return <Text type="h6">{rank}</Text>;
};

export const keyMetricDetailsNavigation = ({
  params,
  code,
  dispatch,
}: {
  params: Record<string, any>;
  code: string;
  dispatch: any;
}) => {
  if (isLmsWeb()) {
    window.location.hash = `/webPlatform/performance/key_metrics/${code}${
      params ? `?${new URLSearchParams(params).toString()}` : ''
    }`;
  } else {
    dispatch(
      renderModule({
        id: KEY_METRICS_DETAILS,
        props: {
          id: code,
          card: params,
        },
      }),
    );
  }
};
